export default "__VITE_ASSET__49dd6d79__"